import { API_URL } from "../constants";
import noImg from "../assets/img/no-img-min.jpeg";

export const getImageSrc = (preview, fromApi) => {
  let src = noImg;
  const formats = [".png", ".jpg", ".jpeg", ".webp"];

  if (preview) {
    src = preview;
  } else if (fromApi) {
    src = `${API_URL}/img/${fromApi}`;
  }

  if (src.includes(API_URL) && !formats.some((f) => src.includes(f))) {
    src = noImg;
  }

  return src;
};

export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const convertDateTime = (date, onlyDate = false) => {
  if (!date) return "";
  const dateTime = new Date(date);
  const formatted = `${dateTime.toLocaleDateString(
    "en-US"
  )} ${dateTime.toLocaleTimeString("en-US")}`;

  if (onlyDate) {
    return dateTime.toLocaleDateString("en-US");
  }
  return formatted;
};

export const convertDate = (date) => {
  const dateTime = new Date(date);
  return `${dateTime.toLocaleDateString("en-US")}`;
};

export const debounce = (func, wait, immediate?: boolean) => {
  let timeout;

  return function executedFunction() {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const getUpdatedValues = (values, item) =>
  Object.keys(values).reduce(
    (acc, key) => ({
      ...acc,
      ...(values[key] !== item[key]
        ? {
            [key]: values[key],
          }
        : {}),
    }),
    {}
  );

export const isNil = (value: unknown) =>
  value === null || value === undefined || value === "" || Number.isNaN(value);
